/**
 * Determine the distance between two points.
 *
 * @param   {object} searchCoords The lat / lng coordinates to center the search on.
 * @param   {object} compCoords   The lat / lng coordinates to compare.
 * @returns {number}              The distance between the searched coordinates in miles.
 */
export function distanceBetween(searchCoords, compCoords) {
    const earthRad = 6371000; // meters

    const diffLat = degreesToRadians(compCoords.lat - searchCoords.lat);
    const diffLng = degreesToRadians(compCoords.lng - searchCoords.lng);

    const searchLat = degreesToRadians(searchCoords.lat);
    const compLat = degreesToRadians(compCoords.lat);

    const a = Math.sin(diffLat / 2) * Math.sin(diffLat / 2) + Math.sin(diffLng / 2) * Math.sin(diffLng / 2) * Math.cos(searchLat) * Math.cos(compLat);
    const b = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return (earthRad * b) / 1609.344; // miles
}

/**
 * Conver numeric degrees to radians.
 *
 * @param   {number} degrees The degrees float to convert.
 * @returns {number}         The radians equivilant.
 */
export function degreesToRadians(degrees) {
    return (degrees * Math.PI) / 180;
}
